<script lang="tsx">
  import { defineComponent } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import ProgressBaseSpinner from './ProgressBaseSpinner.vue'

  export default defineComponent({
    name: 'ProgressSpinner',
    props: {
      /**
       * @ignore
       */
      bs: {
        type: Object,
        default: () => ({}),
      },
      /**
       * 当前进度
       */
      progress: {
        type: Number,
        default: 10,
      },
      /**
       * 是否为指示器(progress百分比)
       */
      indicator: {
        type: Boolean,
        default: true,
      },
      /**
       * 大小
       * @ignore
       */
      size: {
        type: Number,
        default: 32,
      },
    },
    setup(props) {
      return () => (
        <NewBsBox
          bs={{
            width: 104,
            height: 104,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 'control',
            border: '1px solid #d9d9d9',
            borderStyle: 'dashed',
            ...props.bs,
          }}
        >
          <ProgressBaseSpinner
            size={props.size}
            progress={props.progress}
            indicator={props.indicator}
          />
        </NewBsBox>
      )
    },
  })

</script>
